module.exports = __webpack_public_path__ + "img/img2_zhTc.ae5b726b.png";